import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LogLevel } from './LogLevelEnum';

export interface ILoggingService {
    log(message?: any);
    debug(message?: any);
    warn(message?: any);
    error(message?: any);
    info(message?: any);
    verbose(message?: any);
}
@Injectable({
    providedIn: 'root'
})
export class LoggingService implements ILoggingService {
    private static singleton: LoggingService;
    private logLevel: LogLevel;
    constructor() {
        if (LoggingService.singleton) {
            return LoggingService.singleton;
        } else {
            this.logLevel = environment.logLevel || LogLevel.Off;
            // tslint:disable-next-line:no-console
            console.info(
                `Logging service initialized at logging level ${this.logLevel}`
            );
            LoggingService.singleton = this;
            return this;
        }
    }

    /**
   * log
item: any   */
    public log(
        message?: any,
        level: LogLevel = LogLevel.Info,
        ...optionalParams: any[]
    ) {
        if (this.logLevel <= level) {
            console.log(message, optionalParams);
        }
    }

    public debug(message?: any, ...optionalParams: any[]) {
        if (this.logLevel <= LogLevel.Debug) {
            // tslint:disable-next-line:no-console
            console.debug(message, ...optionalParams);
        }
    }
    public warn(message?: any, ...optionalParams: any[]) {
        if (this.logLevel <= LogLevel.Warn) {
            console.warn(message, ...optionalParams);
        }
    }
    public error(message?: any, ...optionalParams: any[]) {
        if (this.logLevel <= LogLevel.Error) {
            console.error(message, optionalParams);
        }
    }
    public info(message?: any, ...optionalParams: any[]) {
        if (this.logLevel <= LogLevel.Info) {
            // tslint:disable-next-line:no-console
            console.info(message, optionalParams);
        }
    }
    // alias for debug
    public verbose(message?: any, ...optionalParams: any[]) {
        if (this.logLevel <= LogLevel.Verbose) {
            this.debug(message, optionalParams);
        }
    }
    public time(label?: any) {
        // tslint:disable-next-line:no-console
        console.time(label);
    }
    public timeLog(label?: any) {
        // tslint:disable-next-line:no-console
        const x = console as any;
        if (x && x.timeLog) {
            (console as any).timeLog(label);
        }
    }
    public timeEnd(label?: any) {
        // tslint:disable-next-line:no-console
        console.timeEnd(label);
    }
    public timeStamp(label?: any) {
        // tslint:disable-next-line:no-console
        console.timeStamp(label);
    }
    public group(label?: any) {
        console.group(label);
    }
    public groupEnd() {
        console.groupEnd();
    }
}

export class NullLogger implements ILoggingService {
    log(message?: any) {}
    debug(message?: any) {}
    warn(message?: any) {}
    error(message?: any) {}
    info(message?: any) {}
    verbose(message?: any) {}
    trace() {}
    time() {}
    timeLog() {}
}
